import { render } from "./ChatInput.vue?vue&type=template&id=027606da&ts=true"
import script from "./ChatInput.vue?vue&type=script&lang=ts"
export * from "./ChatInput.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__